<template>
  <div class="min-h-screen bg-black text-white font-sans flex items-center justify-center">
    <div class="w-full max-w-md px-4">
      <!-- Logo -->
      <div class="flex justify-center mb-8">
        <img src="/icon.png" alt="Ploppin Logo" class="w-16 h-16 rounded-2xl" />
      </div>

      <div class="bg-[#1A2035]/50 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
        <!-- Error Alert -->
        <div v-if="error" class="mb-6 p-4 bg-red-500/20 border border-red-500 rounded-lg text-red-200 text-sm">
          {{ error }}
        </div>
        
        <!-- Success Alert -->
        <div v-if="success" class="mb-6 p-4 bg-green-500/20 border border-green-500 rounded-lg text-green-200 text-sm">
          {{ success }}
        </div>
  
        <!-- Title -->
        <h1 class="text-white text-2xl font-bold text-center mb-2 lowercase">forgot password</h1>
        <p class="text-gray-400 text-center mb-8 lowercase">
          enter your email address, and we'll send you a link to reset your password.
        </p>
  
        <!-- Form -->
        <form @submit.prevent="handleSubmit" class="space-y-6" v-if="!success">
          <!-- Email Input -->
          <div>
            <label class="block text-gray-300 text-sm font-medium mb-2">Email</label>
            <input 
              type="email"
              v-model="email"
              :disabled="isLoading"
              class="w-full bg-gray-700 border border-gray-600 rounded-lg px-4 py-3 text-white placeholder-gray-400 focus:outline-none focus:border-cyan-400 disabled:opacity-50"
              placeholder="Enter your email"
            />
          </div>
  
          <!-- Submit Button -->
          <button 
            type="submit"
            :disabled="isLoading"
            class="w-full bg-gray-700 hover:bg-gray-600 border border-gray-600 py-3 rounded-lg flex items-center justify-center gap-2 transition-colors backdrop-blur-sm text-white font-medium disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <span v-if="isLoading">Sending...</span>
            <span v-else>Send Reset Link</span>
          </button>
        </form>
  
        <!-- Links -->
        <div v-if="success" class="mt-6 text-center">
          <NuxtLink to="/login" class="text-gray-400 hover:text-white">
            Back to Login
          </NuxtLink>
        </div>
      </div>

      <!-- Back to Home -->
      <div class="mt-6 text-center">
        <NuxtLink to="/" class="text-gray-400 hover:text-white transition-colors lowercase">
          ← back to home
        </NuxtLink>
      </div>
    </div>
  </div>
</template>
  
<script setup>
import { ref } from 'vue'
import { useAuth } from '~/composables/useAuth'
  
const { sendPasswordResetEmail } = useAuth()
  
const email = ref('')
const isLoading = ref(false)
const error = ref('')
const success = ref('')
  
const handleSubmit = async () => {
  if (!email.value) {
    error.value = 'Please enter your email address'
    return
  }

  try {
    isLoading.value = true
    error.value = ''
    await sendPasswordResetEmail(email.value)
    success.value = 'Password reset instructions have been sent to your email'
    email.value = '' // Clear the form
  } catch (err) {
    console.error('Password reset error:', err)
    error.value = err.message || 'Failed to send password reset email'
  } finally {
    isLoading.value = false
  }
}
</script>